module.exports = "/* VARIABLES --------------------------------------------------- */\n:root {\n  /* Some variables... */\n}\n\n/* BASE STYLES ------------------------------------------------- */\nbody {\n  font-family: var(--font-stack);\n}\n\na,\nh2 {\n  color: var(--color-primary);\n}\n\nheader {\n  background: linear-gradient(var(--gradient)), url('../img/bg.jpg') no-repeat;\n  background-blend-mode: multiply;\n  background-size: cover;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/assets/usingVariables.css
// module id = 936
// module chunks = 0